<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['regularGameCoins']),

    currentCoins() {
      return this.regularGameCoins || 0;
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    joinYelloRush() {
      this.$router.push({
        path: '/doi',
        query: { coins: this.currentCoins }
      });
    }
  }
}
</script>

<template>
  <div class="containerBlue d-flex flex-column justify-content-start align-items-center col-12">
    <div class="d-flex justify-content-center align-items-center mt-5">
      <img src="@/assets/upsell/yello-rush-upsell.png" class="col-6"/>

    </div>
    <div class="d-flex justify-content-center align-items-center normalText">Recommended Service</div>

    <div class="d-flex flex-column mt-4">
      <div class="d-flex flex-row justify-content-center align-items-center col-12 gap-2">
        <div class="number">+100</div>
        <img src="@/assets/gameplay/coins-large.png" class="col-3 position-relative"/>
      </div>
    </div>

    <div class="d-flex justify-content-center align-items-center normalText mt-4">Compete in top local games on Y’ello
    </div>
    <div class="d-flex justify-content-center align-items-center normalText">Rush and you could WIN a share of</div>
    <div class="d-flex justify-content-center align-items-center normalText"><span class="bold mx-1">R72 000</span> in
      airtime. <span class="bold mx-1">Subscribe, and</span></div>
    <div class="d-flex justify-content-center align-items-center normalText"><span
        class="bold mx-1">score 100 coins</span> for an even better vibe!
    </div>

    <div class="d-flex justify-content-center text-center mt-5 col-12">
      <div class="playButton playText p-3 col-11 join" @click="joinYelloRush">Join Y’ello Rush</div>
    </div>

    <div class="d-flex justify-content-center align-items-center mt-4 backbut" @click="closeModal">No Thank You</div>

    <div class="d-flex flex-column col-12 tcs mt-5">
      <div class="d-flex justify-content-center align-items-center normalText mt-3 col-12">R5/day. Subscription service.</div>
      <div class="d-flex justify-content-center align-items-center texttcs col-12" @click="this.$router.push('/terms')">Terms and Conditions</div>
    </div>


  </div>
</template>

<style scoped>
.containerBlue {
  background: rgba(0, 0, 21, 0.82);
  backdrop-filter: blur(3px);
  min-height: 100vh;
  position: relative;

}

.number {
  font-weight: 700;
  font-size: 37px;
  color: #ffffff;
}

.playButton {
  background-color: #FFCB05;
  border-radius: 29px;
}

.backbut {
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  text-decoration: underline;

}

.join {
  font-weight: 600;
  font-size: 19px;
}

.normalText {
  font-weight: 400;
  font-size: 15px;
  color: #D8D8D8;

}

.bold {
  font-weight: 600;
  color: #FFFFFF;

}

.tcs {
  position: absolute;
  bottom: 5%;
}

.texttcs {
  text-decoration: underline;
  color: #007AFF;
  font-weight: 400;
  font-size: 15px;
}

</style>